(function($) {
    if(!document.querySelector('body.gp-endpoint-pos-return')){
        return;
    }

    $('[data-pos-return-ajax]').on('click', function(){
        let url = this.getAttribute('data-pos-return-ajax');
        function error(message){
            if(!message){
                message = 'Chyba komunikace';
            }
            alert(message);
        }
        gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: {
                'return_id': this.getAttribute('data-return-id'),
                'pos_action': this.getAttribute('data-action'),
            }
        })
        .done((data) => {
            if(!data.success){
                error(data.data.error);
            }
        })
        .fail(() => {
            error();
        })
    })

})(jQuery);